import { toHTML, } from "@portabletext/to-html";
import { throwError, } from "../../index.js";
import { resolveTable } from "./html.js";
const toManagementApiImage = (image) => createFigureTag(image.asset._ref);
const toManagementApiRichTextItem = (richTextItem) => `<object type="application/kenticocloud" data-type="${richTextItem.dataType}" data-id="${richTextItem.component._ref}"></object>`;
const toManagementApiTable = (table) => resolveTable(table, (blocks) => toHTML(blocks, portableTextComponents));
const toManagementApiExternalLink = (children, link) => link
    ? `<a ${createExternalLinkAttributes(link)}>${children}</a>`
    : throwError("Mark definition for external link not found.");
const toManagementApiInternalLink = (children, link) => link
    ? `<a data-item-id="${link.reference._ref}">${children}</a>`
    : throwError("Mark definition for item link not found.");
const createImgTag = (assetId) => `<img src="#" data-asset-id="${assetId}">`;
const createFigureTag = (assetId) => `<figure data-asset-id="${assetId}">${createImgTag(assetId)}</figure>`;
const createExternalLinkAttributes = (link) => Object.entries(link).filter(([k]) => k !== "_type" && k !== "_key").map(([k, v]) => `${k}="${v}"`).join(" ");
/**
 * specifies resolution for custom types and marks that are not part of `toHTML` default implementation.
 */
const portableTextComponents = {
    components: {
        types: {
            image: ({ value }) => toManagementApiImage(value),
            component: ({ value }) => toManagementApiRichTextItem(value),
            table: ({ value }) => toManagementApiTable(value),
        },
        marks: {
            internalLink: ({ children, value }) => toManagementApiInternalLink(children, value),
            link: ({ children, value }) => toManagementApiExternalLink(children, value),
            sub: ({ children }) => `<sub>${children}</sub>`,
            strong: ({ children }) => `<strong>${children}</strong>`,
            sup: ({ children }) => `<sup>${children}</sup>`,
            em: ({ children }) => `<em>${children}</em>`,
        },
    },
};
/**
 * Transforms Portable Text initially created from Kontent.ai management API rich text back to MAPI-compatible format.
 *
 * This function performs only minimal checks for compatibility and is therefore not suited for conversion of generic HTML
 * or any other rich text other than MAPI format.
 *
 * @param blocks portable text array
 * @returns MAPI-compatible rich text string
 */
export const toManagementApiFormat = (blocks) => toHTML(blocks, portableTextComponents);
